<template>
  <div v-if="dataLoaded && targetsLoaded">

    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-6" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push(`/faq`)"
          icon="keyboard_backspace"
        />
      </div>

      <div class="col-6">
        <q-btn
          class="capitalize ctrl-button right q-ml-md"
          :color="readOnly ? 'grey-5' :'ctrl-turquoise'"
          :label="readOnly ? getString('action.edit') : getString('action.save')"
          @click="saveChanges()"
          :icon-right="readOnly ? 'edit' : 'save'"
        />
        <q-btn v-if="data.id"
          class="q-ml-md capitalize ctrl-button right"
          icon-right="delete"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          @click="deleteCategory()"
          align="right"
        />
      </div>
    </div>

    <div class="row gutter-sm q-mb-lg">
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
            Faq question
        </p>
        <div class="card-block">
          <!-- Name -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.title"
              @input="suggestUrl"
              :disable="readOnly"
              :float-label="getString('title')">
            </q-input>
          </q-field>

          <!-- Url -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.url"
              :disable="readOnly"
              float-label="Url">
            </q-input>
          </q-field>

          <!-- category -->
          <q-field class="q-mb-md">
            <q-select v-if="data.category"
              :float-label="getString('category')"
              v-model="data.category.id"
              :disable="readOnly"
              @input="val => updateCategory(val)"
              :options="categories"
              class="full-width q-ml-md q-mr-md"
            />
            <q-select v-else
              :float-label="'Category'"
              v-model="noCategory"
              :disable="readOnly"
              :options="categories"
              @input="val => updateCategory(val)"
              class="full-width q-ml-md q-mr-md"
            />
          </q-field>

          <!-- Targets -->
          <q-select
            multiple
            v-model="data.targets"
            :disable="readOnly"
            :options="targetOptions"
            :float-label="getString('editor.block.header.targets')"/>

            <div class="row q-mb-sm">
              <q-toggle class="q-mt-md" color="secondary" v-model="data.online">
              <span style="margin-left: 1em;">
                Online
              </span>
              </q-toggle>
            </div>

          <div class="row q-mb-sm">
            <q-toggle class="q-mt-md" color="secondary" v-model="data.login.contact">
            <span style="margin-left: 1em;">
              {{ getString('module.faq.question.field.login.contact') }}
            </span>
            </q-toggle>
          </div>

          <div class="row q-mb-sm">
            <q-toggle class="q-mt-md" color="secondary" v-model="data.login.resource">
            <span style="margin-left: 1em;">
              {{ getString('module.faq.question.field.login.resource') }}
            </span>
            </q-toggle>
          </div>
        </div>
      </div>

      <!-- Meta -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pl-sm">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ 'Meta' }}
            </p>

            <div class="card-block">
              <div class="row">
                <q-input
                  :disable="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.seo.title')"
                  v-model="data.meta.seo.title"
                />
                <q-input
                  :disable="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.seo.description')"
                  v-model="data.meta.seo.description"
                />
                <q-input
                  :disable="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.og.title')"
                  v-model="data.meta.og.title"
                />
                <q-input
                  :disable="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.og.description')"
                  v-model="data.meta.og.description"
                />
                <q-input
                  :disable="readOnly"
                  type="text"
                  class="full-width q-mb-md"
                  :float-label="getString('editor.meta.canonical')"
                  v-model="data.meta.canonical"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- FAQ content editor -->
    <div class="row gutter-sm q-mb-lg q-mt-sm">
      <div class="full-width">
        <p class="card-title">{{ getString('block.type.html.content') }}</p>
        <div class="card-block scroll">

          <!-- Field: HTML Editor -->
          <tiny-editor
            tinymce-script-src="https://cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.11/tinymce.min.js"
            :init="tinyConfig()"
            ref="tm"
            :disabled="readOnly"
            v-model="data.content">
          </tiny-editor>
        </div>
      </div>
    </div>

      <!-- Products -->
      <div class="col-md-6 col-sm-12 col-xs-12 q-pl-sm">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">
              {{ 'Products' }}
            </p>

            <div class="card-block">
              <div class="row">
                <chips-autocomplete
                  @updateAutocomplete="updateItems(...arguments)"
                  :readonly="readOnly"
                  :disable="readOnly"
                  class="q-pb-md full-width"
                  :selection="data.products"
                  :name="'Items'"
                  :labelTerm="'code'"
                  :endpoint="'item'"
                  :resultLabel="'items'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import qs from 'qs';
import ChipsAutocomplete from '@/components/ChipsAutocomplete.vue';
import saveChanges from '@/mixins/detailViews/saveChanges';
import suggestUrl from '@/mixins/suggestUrl';
import getString from '@/helpers/GetStrings';

const TinyEditor = require('@tinymce/tinymce-vue').default;

export default {
  data() {
    return {
      noCategory: null,
      categories: [],
      dataLoaded: false,
      // Name of the module defined in user rights. eg. blog for blog.edit, blog.add etc..
      //   permission: 'faq',
      // The object key from the response object
      responseData: {
        multiple: 'questions',
        single: 'faq',
      },
      targetsLoaded: false,
      targetOptions: [],
      // Used for navigation on the front-end (matching the router)
      module: 'faq/category',
      data: {
        targets: [],
        category: {
          id: null,
          name: null,
        },
        name: '',
        products: [],
        online: true,
        url: '',
        login: {
          contact: false,
          resource: false,
        },
        meta: {
          seo: {
            description: '',
            title: '',
          },
          og: {
            description: '',
            title: '',
          },
          canonical: '',
        },
      },
    };
  },

  components: {
    ChipsAutocomplete,
    TinyEditor,
  },

  mixins: [
    suggestUrl,
    saveChanges,
  ],
  methods: {
    updateItems(value) {
      this.data.products = value;
    },
    getTargets() {
      this.axios.get('target').then((res) => {
        this.targetOptions = res.data && res.data.targets && res.data.targets.map(target => ({ label: target.label, value: target.id }));
        this.targetsLoaded = true;
      }).catch((err) => {
        console.warn(err);
      });
    },

    // Method to fetch categories
    getCategories() {
      this.axios.get('faq/category').then((res) => {
        this.categories = res.data.categories.map(option => ({ value: option.id, label: option.name }));
      }).catch((err) => {
        console.warn(err);
      });
    },

    updateCategory(val) {
      if (!this.data.category) {
        this.data.category = {};
      }
      this.data.category.id = val;
    },

    tinyConfig() {
      return {
        readOnly: false,
        height: 200,
        menubar: false,
        branding: false,
        browser_spellcheck: true,
        plugins: ['link'],
        toolbar: [
          'undo redo | bold | pagebreak | link',
        ],
        style_formats: [
          { title: 'Paragraph', format: 'p' },
          { title: 'Heading 1', format: 'h1' },
          { title: 'Heading 2', format: 'h2' },
        ],
        pagebreak_split_block: false,
      };
    },
    getString,

    deleteCategory() {
      // Dialog
      this.$q.dialog({
        title: '',
        message: this.getString('module.library.delete.title.single'),
        ok: this.$store.state.stringsStore.strings.dialog.confirm.ok,
        cancel: this.$store.state.stringsStore.strings.dialog.confirm.cancel,
      }).then(() => {
        // delete call
        this.axios.delete(`faq/category/${this.$route.params.category}/question/${this.data.id}`)
          .then(() => {
            // Refresh data to see the result
            this.$q.notify({
              message: this.getString('upload.delete.success').replace('%file%', this.getString('category')),
              position: 'top-right',
              timeout: 1000,
              color: 'positive',
            });
            this.$router.push('/faq');
          })
          .catch((error) => {
            // Error
            console.warn(error);
          });
      }).catch(() => {
        console.warn('Not removed');
      });
    },

    requestParams() {
      const requiredFields = {
        target: [...new Set(this.data.targets)],
        category_id: this.data.category.id,
        title: this.data.title,
        url: this.data.url,
        content: this.data.content,
        online: this.data.online ? '1' : '0',
        login_contact: this.data.login.contact ? '1' : '0',
        login_resource: this.data.login.resource ? '1' : '0',
      };

      const optional = {
        meta_seo_title: this.data.meta.seo.title,
        meta_seo_description: this.data.meta.seo.description,
        meta_og_title: this.data.meta.og.title,
        meta_og_description: this.data.meta.og.description,
        meta_canonical: this.data.meta.canonical,
        product: this.data.products && this.data.products.length > 0 ? [...new Set(this.data.products.map(p => p.id))] : null,
      };


      // If a value is null, undefined or empty, remove it from fields
      for (const [key, value] of Object.entries(optional)) {
        if (value === null || value === undefined) delete optional[key];
      }

      // Join required and optional
      const fields = Object.assign(requiredFields, optional);

      return fields;
    },

    toggle(value, param) {
      this.axios.put(`${this.endpoint}/${this.data.id}`, qs.stringify({ [param]: value ? 1 : 0 }));
    },
  },

  computed: {
    endpoint() {
      const category = this.$route.params.category ? this.$route.params.category : this.data.category.id;
      return `faq/category/${category}/question`;
    },
  },

  filters: {
    checkEmpty(value) {
      return value === null || value === '' ? '-' : value;
    },

    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },

  mounted() {
    this.getCategories();
    this.getTargets();
    if (this.$route.params.id) this.readOnly = true;
  },
  created() {
    if (this.$route.params.id) {
    // Fetch the selected module details by id.
      this.axios.get(`/${this.endpoint}/${this.$route.params.id}`)
        .then((response) => {
        // In the module detail page, if a given id is not found, we will always get a 200 OK response.
          if (!response.data[this.responseData.single]) {
          // Redirect to modules overview
            this.$router.push(`/${this.module}`);
            return;
          }

          this.data = response.data[this.responseData.single];

          // Apply selected tags from props
          if (this.data.targets && this.data.targets.length) {
            this.data.targets = this.data.targets.map(target => target.id);
          }

          this.dataLoaded = true;
        })
        .catch((error) => {
          console.warn(error);

          // Notify if nothing found
          if (error.response.status === 404) {
            this.$q.notify({
              message: getString(`module.${this.module}.edit.error.nothingFound`),
              type: 'warning',
              timeout: 2000,
              position: 'top-right',
            });
          } else {
          // Throw general error notification
            this.$q.notify({
              message: getString('error.general'),
              position: 'top-right',
              timeout: 1000,
              type: 'warning',
            });
          }

          // Redirect to modules overview
          this.$router.push(`/${this.module}`);
        });
    } else {
      // Nothing to load
      this.dataLoaded = true;
    }
  },
};
</script>


<style lang="stylus" scoped>
@import '~variables';
.data-title
  font-weight 700

.data-content
  word-break break-all

</style>
